import { useSyncExternalStore } from "react";

/**
 * A phone's width: below 640px (Tailwind's `sm:`), the one breakpoint at which
 * a PAPER table stops drawing every column and FITS instead — the columns a
 * phone cannot hold move under the row's name, so nothing the desk shows is
 * lost (founder, 2026-10-03: "we need to fix the responsive too"; the Stock
 * page's compact list was the first, see `IngredientsPage`).
 *
 * Kept apart from `useIsMobile` (1024px, which only decides the shell's
 * sidebar): a tablet has room for the whole table.
 */
export const PHONE_MEDIA_QUERY = "(max-width: 639px)";

function query(): MediaQueryList | null {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(PHONE_MEDIA_QUERY)
    : null;
}

/** `true` below 640px; `false` where there is no `matchMedia` (tests, SSR). */
export function usePhoneWidth(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = query();
      if (!list) return () => {};
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => query()?.matches ?? false,
    () => false,
  );
}
